export class Reservation {
    constructor(activite: number | null = null, date = '', commentaire = '', autobus = false) {
        this.date = date;
        this.activite = activite;
        this.commentaire = commentaire;
        this.autobus = autobus;
    }

    /**
     *
     */
    date: string;
    activite: number | null;
    commentaire: string;
    autobus: boolean;
}
